import React, { useEffect, useState } from "react";
import { cn } from "@/lib/utils";
import { ChevronDown, Loader2 } from "lucide-react";

const ThinkingIndicator = ({ className, isPopupContent = false, isActive = false, thinkingMessages = [] }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(isActive);
  }, [isActive]);

  // Sử dụng trực tiếp array thinking messages từ API
  const displaySteps = thinkingMessages.length > 0 ? thinkingMessages : ["Đang xử lý yêu cầu của bạn..."];

  return (
    <div className={cn("relative my-2", className)}>
      <button
        className={cn(
          "flex items-center px-3 py-2 rounded-lg border border-gray-200 bg-gray-50 hover:bg-gray-100 transition-colors cursor-pointer select-none w-fit",
          isPopupContent ? "text-sm" : "text-md"
        )}
        onClick={() => setOpen((v) => !v)}
      >
        {/* Loading spinner hiện đại - chỉ hiện khi đang active */}
        {isActive && <Loader2 className="w-4 h-4 mr-2 animate-spin text-blue-500" />}

        <span className="font-medium text-sm text-gray-700">Suy luận</span>

        {/* Nút dropdown luôn ở cuối */}
        <ChevronDown className={cn("transition-transform duration-300 ease-in-out ml-2", open ? "rotate-180" : "rotate-0", "w-4 h-4")} />
      </button>

      {/* Chi tiết thinking với smooth transition */}
      <div className={cn("overflow-hidden transition-all duration-300 ease-in-out", open ? "max-h-96 opacity-100" : "max-h-0 opacity-0")}>
        <div className="my-4 pl-4 border-l-2 border-gray-200 text-gray-500">
          <div className="text-sm space-y-2">
            {displaySteps.map((step, index) => (
              <div key={index} className="flex items-start">
                <div className={cn("w-2 h-2 rounded-full mr-2 mt-1.5 animate-pulse", index % 3 === 0 ? "bg-blue-500" : index % 3 === 1 ? "bg-green-500" : "bg-orange-500")}></div>
                <span>{step}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThinkingIndicator;
